// eslint-disable-next-line @typescript-eslint/no-var-requires
exports.wrapPageElement = require('./dist/gatsby-browser').wrapPageElement;
